import { render } from "./timeuntil.vue?vue&type=template&id=9de512b2"
import script from "./timeuntil.vue?vue&type=script&lang=js"
export * from "./timeuntil.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__